import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import AuthTabs from "./AuthTabs";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import ConfirmEmailForm from "./ConfirmEmailForm";

/**
 * login | signup | confirm
 */
const AuthPanel = () => {
  const location = useLocation();
  const [view, setView] = useState(location.state?.fromDemo ? "signup" : "login");
  const [confirmEmail, setConfirmEmail] = useState(
    location.state?.email || ""
  );
  const [pendingPassword, setPendingPassword] = useState("");

  if (view === "confirm") {
    return (
      <div>
        <h2 className="text-lg font-semibold text-foreground mb-1 text-center">
          Confirmar e-mail
        </h2>
        <ConfirmEmailForm
          email={confirmEmail}
          passwordForAutoLogin={pendingPassword}
        />
      </div>
    );
  }

  return (
    <div>
      <AuthTabs
        active={view}
        onChange={(id) => {
          setView(id);
          setPendingPassword("");
        }}
      />

      {view === "login" ? (
        <LoginForm
          onNeedsConfirmation={(email) => {
            setConfirmEmail(email);
            setView("confirm");
          }}
          onSwitchToSignup={() => setView("signup")}
        />
      ) : (
        <SignupForm
          onSignupSuccess={(email, password) => {
            setConfirmEmail(email);
            setPendingPassword(password || "");
            setView("confirm");
          }}
          onSwitchToLogin={() => setView("login")}
        />
      )}

      {location.state?.fromDemo && view === "signup" && (
        <p className="mt-4 text-sm text-muted-foreground text-center" role="status">
          {location.state?.signupHint ||
            "Crie sua conta para gerar o PDF e salvar seu documento como rascunho."}
        </p>
      )}

      {location.state?.confirmed && view === "login" && (
        <p className="mt-4 text-sm text-success text-center" role="status">
          E-mail confirmado. Faça login para continuar.
        </p>
      )}
    </div>
  );
};

export default AuthPanel;
